<template>
  <div v-if="active" class="account-blocked-inpage">
    <div class="account-blocked-inpage__card">
      <div class="account-blocked-inpage__icon-wrap" aria-hidden="true">
        <svg class="account-blocked-inpage__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
        </svg>
      </div>
      <h2 class="account-blocked-inpage__title">{{ title }}</h2>
      <p class="account-blocked-inpage__desc">{{ description }}</p>
      <button type="button" class="account-blocked-inpage__cta" @click="goSupport">
        {{ t('accountBlocked.supportCta') }}
      </button>
      <button type="button" class="account-blocked-inpage__back" @click="close">
        {{ t('accountBlocked.back') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useAccountAccessBlock } from '../../composables/useAccountAccessBlock'

const { t } = useI18n()
const router = useRouter()
const { inPageActive, inPageReason, closeInPageBlock } = useAccountAccessBlock()

const active = computed(() => inPageActive.value)

const title = computed(() =>
  inPageReason.value === 'owner'
    ? t('accountBlocked.inPage.ownerTitle')
    : t('accountBlocked.inPage.selfTitle')
)

const description = computed(() =>
  inPageReason.value === 'owner'
    ? t('accountBlocked.inPage.ownerDescription')
    : t('accountBlocked.inPage.selfDescription')
)

const close = () => closeInPageBlock()

const goSupport = async () => {
  closeInPageBlock()
  await router.push('/suporte')
}
</script>

<style scoped>
.account-blocked-inpage {
  position: absolute;
  inset: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  background: color-mix(in srgb, var(--bg-primary) 82%, transparent);
  backdrop-filter: blur(10px);
}

.account-blocked-inpage__card {
  width: min(100%, 440px);
  padding: 36px 32px 28px;
  border-radius: 18px;
  border: 1px solid color-mix(in srgb, #ef4444 22%, var(--border-primary));
  background: var(--bg-primary);
  text-align: center;
  box-shadow: 0 20px 40px color-mix(in srgb, #000 12%, transparent);
}

.account-blocked-inpage__icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin-bottom: 16px;
  border-radius: 14px;
  color: #ef4444;
  background: color-mix(in srgb, #ef4444 10%, transparent);
}

.account-blocked-inpage__icon {
  width: 26px;
  height: 26px;
}

.account-blocked-inpage__title {
  margin: 0 0 10px;
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--text-primary);
}

.account-blocked-inpage__desc {
  margin: 0 0 22px;
  font-size: 0.9375rem;
  line-height: 1.55;
  color: var(--text-secondary);
}

.account-blocked-inpage__cta {
  width: 100%;
  padding: 11px 18px;
  border: none;
  border-radius: 10px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  background: linear-gradient(135deg, #6366f1, #7c3aed);
}

.account-blocked-inpage__back {
  margin-top: 10px;
  padding: 8px;
  border: none;
  background: none;
  font-size: 0.8125rem;
  color: var(--text-secondary);
  cursor: pointer;
}
</style>
